<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { getParam, logout } from '@/lib/utils'
import { Ellipsis, User } from 'lucide-vue-next'
import { useRoute } from 'vue-router'
import { store } from '@/store/store';
import { computed } from 'vue';

const numberOfPatients = computed(() => {
    return store.members?.length || 0;
});

const route = useRoute();
</script>

<template>
    <div>
        <Button v-if="!store.loginFlag" variant="ghost" size="icon" class="border bg-white cursor-pointer" as-child>

        </Button>
        <Button v-else-if="route.name === 'profiles' || (route.name === 'profile' && numberOfPatients === 1)"
            variant="ghost" size="icon" class="border bg-white cursor-pointer" as-child>
            <RouterLink :to="{ name: 'account', params: { domain: getParam(route) } }" class="w-11">
                <Ellipsis class="size-5" />
            </RouterLink>
        </Button>
        <Button v-else-if="['login', 'address'].includes(route.name as string)" variant="ghost"
            class="border bg-white cursor-pointer" @click="logout(route)">
            Logout
        </Button>
        <Button v-else variant="ghost" size="icon" class="border bg-white cursor-pointer" as-child>
            <RouterLink :to="{ name: 'profiles', params: { domain: getParam(route) } }" class="w-11">
                <User class="size-5" />
            </RouterLink>
        </Button>
    </div>
</template>
